// Created by Claude Code AI Agent

import { Component, inject } from '@angular/core';
import { IonicModule, ModalController } from '@ionic/angular/lazy';

@Component({
  selector: 'sm-update-error-modal',
  templateUrl: './update-error.modal.html',
  styleUrls: ['./update-error.modal.scss'],
  standalone: true,
  imports: [IonicModule]
})
export class UpdateErrorModalComponent {
  private readonly modalController = inject(ModalController);

  report: string;
  copied = false;

  async copy() {
    try {
      await navigator.clipboard.writeText(this.report);
      this.copied = true;
    } catch {
      this.copied = this.copyWithTextarea();
    }
  }

  async close() {
    await this.modalController.dismiss();
  }

  // navigator.clipboard can be unavailable or denied inside a WebView; the legacy copy command still works there.
  private copyWithTextarea() {
    const textarea = document.createElement('textarea');
    textarea.value = this.report;
    textarea.style.position = 'fixed';
    textarea.style.opacity = '0';
    document.body.appendChild(textarea);
    textarea.select();
    const copied = document.execCommand('copy');
    textarea.remove();
    return copied;
  }
}
